import { serviceListEntrypoint } from '@jira/spa-apps__servicedesk-servicedesk-service-list/src/serviceListEntrypoint.entrypoint.tsx';
import { serviceDeskServiceListRoute } from '@jira/router-routes__servicedesk-service-list-routes/src/serviceDeskServiceListRoute.tsx';
import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import { assetsPrimaryWorkspaceResource } from '@jira/router-resources__assets-primary-workspace/src/assetsPrimaryWorkspaceResource.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

import { getInsightResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const serviceDeskServiceListAppPageEntryPoint = createPageEntryPoint({
	main: serviceListEntrypoint,
});

// TODO: Remove this resources when backend responses are ready.
const getConditionalInsightResources = () =>
	getInsightResources().map((resource) =>
		resourceWithCondition(() => fg('service-list-sidebar-item'), resource),
	);

// Resolves the primary Assets site cloud id + workspace id (via the units /
// collaboration-context-aware resolver) before the page renders, so the Assets
// GraphQL request targets the primary site on its first fetch. Gated so that
// when the gate is OFF the resource is a no-op and behaviour is unchanged.
const getAssetsPrimaryWorkspaceResource = () =>
	resourceWithCondition(
		() => fg('jsm_service_list_units_primary_site'),
		assetsPrimaryWorkspaceResource,
	);

export const serviceDeskServiceListRouteEntry: Route = createEntry(
	serviceDeskServiceListRoute,
	() => ({
		group: 'servicedesk',
		layout: globalLayout,
		navigation: {
			menuId: MenuIdPeople,
		},

		resources: [
			...getNavigationResources(),
			workspaceResource,
			getAssetsPrimaryWorkspaceResource(),
			...getConditionalInsightResources(),
		],

		entryPoint() {
			return fg('service-list-sidebar-item') ? serviceDeskServiceListAppPageEntryPoint : undefined;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
